

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchHolidayList, updateHolidayByAdmin } from "../redux/actions/holidayActions";
// import theme from "../components/shared/theme";
// import {
//   dropdownStyle,
//   thStyle,
//   tdStyle,
//   paginationButtonStyle,
// } from "../components/shared/themeStyles";

// const ViewHoliday = () => {
//   const dispatch = useDispatch();
//   const { holidays, loading, error } = useSelector((state) => state.holiday);

//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [selectedHoliday, setSelectedHoliday] = useState(null);
//   const [formData, setFormData] = useState({
//     holiday_name: "",
//     holiday_date: "",
//     description: "",
//   });

//   useEffect(() => {
//     dispatch(fetchHolidayList());
//   }, [dispatch]);

//   const handleEditClick = (holiday) => {
//     setSelectedHoliday(holiday);
//     setFormData({
//       holiday_name: holiday.holiday_name,
//       holiday_date: holiday.holiday_date.slice(0, 10), // for input type="date"
//       description: holiday.description,
//     });
//     setEditModalOpen(true);
//   };

//   const handleUpdate = () => {
//     if (!selectedHoliday) return;
//     const updatedData = {
//       id: selectedHoliday.id,
//       ...formData,
//     };
//     dispatch(updateHolidayByAdmin(updatedData)).then(() => {
//       setEditModalOpen(false);
//       setSelectedHoliday(null);
//     });
//   };

//   return (
//     <div style={{ backgroundColor: theme.colors.background, padding: theme.spacing.md, minHeight: "100vh" }}>
//       <h1 style={{ fontSize: theme.font.size["2xl"], fontWeight: theme.font.weight.bold, marginBottom: theme.spacing.md }}>
//         Holiday List
//       </h1>

//       {loading ? (
//         <p style={{ fontSize: theme.font.size.base }}>Loading holidays...</p>
//       ) : error ? (
//         <div
//           style={{
//             backgroundColor: theme.colors.dangerLight,
//             border: `1px solid ${theme.colors.danger}`,
//             color: theme.colors.dangerText,
//             padding: theme.spacing.sm,
//             borderRadius: theme.radius.md,
//             marginBottom: theme.spacing.md,
//           }}
//         >
//           Error: {error}
//         </div>
//       ) : holidays.length > 0 ? (
//         <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
//           <table className="min-w-[900px] w-full text-sm text-left">
//             <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
//               <tr>
//                 <th style={thStyle}>#</th>
//                 <th style={thStyle}>Holiday Name</th>
//                 <th style={thStyle}>Date</th>
//                 <th style={thStyle}>Description</th>
//                 <th style={thStyle}>District</th>
//                 <th style={thStyle}>Municipality</th>
//                 <th style={thStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {holidays.map((holiday, index) => (
//                 <tr key={holiday.id || index} className="hover:bg-gray-50">
//                   <td style={tdStyle}>{index + 1}</td>
//                   <td style={tdStyle}>{holiday.holiday_name || "-"}</td>
//                   <td style={tdStyle}>
//                     {holiday.holiday_date
//                       ? new Date(holiday.holiday_date).toLocaleDateString("en-IN")
//                       : "-"}
//                   </td>
//                   <td style={tdStyle}>{holiday.description || "-"}</td>
//                   <td style={tdStyle}>{holiday.district_name || "-"}</td>
//                   <td style={tdStyle}>{holiday.municipality_name || "-"}</td>
//                   <td style={tdStyle}>
//                     <button
//                       onClick={() => handleEditClick(holiday)}
//                       style={{
//                         backgroundColor: theme.colors.primary,
//                         color: "white",
//                         borderRadius: theme.radius.sm,
//                         padding: "4px 10px",
//                         fontSize: theme.font.size.sm,
//                       }}
//                     >
//                       Edit
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p style={{ fontSize: theme.font.size.base }}>No holidays found.</p>
//       )}

//       {/* Edit Modal */}
//       {editModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
//             <h2 className="text-xl font-semibold mb-4">Edit Holiday</h2>

//             <label className="block mb-2 text-sm font-medium">Holiday Name</label>
//             <input
//               type="text"
//               value={formData.holiday_name}
//               onChange={(e) => setFormData({ ...formData, holiday_name: e.target.value })}
//               className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
//             />

//             <label className="block mb-2 text-sm font-medium">Holiday Date</label>
//             <input
//               type="date"
//               value={formData.holiday_date}
//               onChange={(e) => setFormData({ ...formData, holiday_date: e.target.value })}
//               className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
//             />

//             <label className="block mb-2 text-sm font-medium">Description</label>
//             <textarea
//               value={formData.description}
//               onChange={(e) => setFormData({ ...formData, description: e.target.value })}
//               className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
//               rows="3"
//             ></textarea>

//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={() => setEditModalOpen(false)}
//                 className="bg-gray-400 text-white px-4 py-2 rounded"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleUpdate}
//                 className="bg-blue-600 text-white px-4 py-2 rounded"
//               >
//                 Update
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ViewHoliday;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchHolidayList,
  updateHolidayByAdmin,
} from "../redux/actions/holidayActions";
import {
  fetchDistricts,
  fetchMunicipalities,
} from "../redux/actions/locationActions";
import theme from "../components/shared/theme";
import {
  thStyle,
  tdStyle,
} from "../components/shared/themeStyles";

const ViewHoliday = () => {
  const dispatch = useDispatch();

  const { holidays, loading, error } = useSelector((state) => state.holiday);
  const { districts = [], municipalities = [] } = useSelector((state) => state.location);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [formData, setFormData] = useState({
    holiday_name: "",
    holiday_date: "",
    description: "",
    district_id: "",
    municipality_id: "",
  });

  useEffect(() => {
    dispatch(fetchHolidayList());
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
  }, [dispatch]);

  const handleEditClick = (holiday) => {
    setSelectedHoliday(holiday);
    setFormData({
      holiday_name: holiday.holiday_name,
      holiday_date: holiday.holiday_date.slice(0, 10),
      description: holiday.description,
      district_id: holiday.district_id || "",
      municipality_id: holiday.municipality_id || "",
    });
    setEditModalOpen(true);
  };

  const handleUpdate = () => {
    if (!selectedHoliday) return;

    const updatedData = {
      id: selectedHoliday.id,
      ...formData,
    };

    dispatch(updateHolidayByAdmin(updatedData)).then(() => {
      setEditModalOpen(false);
      setSelectedHoliday(null);
    });
  };

  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        padding: theme.spacing.md,
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: theme.font.size["2xl"],
          fontWeight: theme.font.weight.bold,
          marginBottom: theme.spacing.md,
        }}
      >
        Holiday List
      </h1>

      {loading ? (
        <p style={{ fontSize: theme.font.size.base }}>Loading holidays...</p>
      ) : error ? (
        <div
          style={{
            backgroundColor: theme.colors.dangerLight,
            border: `1px solid ${theme.colors.danger}`,
            color: theme.colors.dangerText,
            padding: theme.spacing.sm,
            borderRadius: theme.radius.md,
            marginBottom: theme.spacing.md,
          }}
        >
          Error: {error}
        </div>
      ) : holidays.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[900px] w-full text-sm text-left">
            <thead
              style={{
                backgroundColor: theme.colors.grayDark,
                color: "white",
              }}
            >
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Holiday Name</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Description</th>
                <th style={thStyle}>District</th>
                <th style={thStyle}>Municipality</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {holidays.map((holiday, index) => (
                <tr key={holiday.id || index} className="hover:bg-gray-50">
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{holiday.holiday_name || "-"}</td>
                  <td style={tdStyle}>
                    {holiday.holiday_date
                      ? new Date(holiday.holiday_date).toLocaleDateString("en-IN")
                      : "-"}
                  </td>
                  <td style={tdStyle}>{holiday.description || "-"}</td>
                  <td style={tdStyle}>
                    {holiday.district_name || <span className="text-gray-400">-</span>}
                  </td>
                  <td style={tdStyle}>
                    {holiday.municipality_name || <span className="text-gray-400">-</span>}
                  </td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => handleEditClick(holiday)}
                      style={{
                        backgroundColor: theme.colors.primary,
                        color: "white",
                        borderRadius: theme.radius.sm,
                        padding: "4px 10px",
                        fontSize: theme.font.size.sm,
                      }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p style={{ fontSize: theme.font.size.base }}>No holidays found.</p>
      )}

      {/* Edit Modal */}
      {editModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
            <h2 className="text-xl font-semibold mb-4">Edit Holiday</h2>

            <label className="block mb-2 text-sm font-medium">Holiday Name</label>
            <input
              type="text"
              value={formData.holiday_name}
              onChange={(e) =>
                setFormData({ ...formData, holiday_name: e.target.value })
              }
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
            />

            <label className="block mb-2 text-sm font-medium">Holiday Date</label>
            <input
              type="date"
              value={formData.holiday_date}
              onChange={(e) =>
                setFormData({ ...formData, holiday_date: e.target.value })
              }
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
            />

            <label className="block mb-2 text-sm font-medium">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
              rows="3"
            ></textarea>

            <label className="block mb-2 text-sm font-medium">District</label>
            <select
              value={formData.district_id}
              onChange={(e) =>
                setFormData({ ...formData, district_id: parseInt(e.target.value) })
              }
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
            >
              <option value="">Select District</option>
              {districts.map((dist) => (
                <option key={dist.id} value={dist.id}>
                  {dist.name}
                </option>
              ))}
            </select>

            <label className="block mb-2 text-sm font-medium">Municipality</label>
            <select
              value={formData.municipality_id}
              onChange={(e) =>
                setFormData({ ...formData, municipality_id: parseInt(e.target.value) })
              }
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
            >
              <option value="">Select Municipality</option>
              {municipalities.map((mun) => (
                <option key={mun.id} value={mun.id}>
                  {mun.name}
                </option>
              ))}
            </select>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setEditModalOpen(false)}
                className="bg-gray-400 text-white px-4 py-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdate}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewHoliday;
